import React from 'react';
import Modal from 'react-modal';
import './CreativeLibrary.css';

interface CreativeTrackerProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const CreativeLibrary: React.FC<CreativeTrackerProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="creative-modal"
      overlayClassName="creative-overlay"
    >
      <div className="modal-header-fc">
        <button onClick={onRequestClose} className="close-button">&times;</button>
      </div>
      
      <div style={{ width: '100%', height: '90vh', overflow: 'hidden' }}>
      <iframe title="Apple TV+ Creative Tracker" width="100%" height="100%" src="https://app.powerbi.com/reportEmbed?reportId=2664efdd-976e-417c-8879-97516d19aec1&autoAuth=true&ctid=41eb501a-f671-4ce0-a5bf-b64168c3705f" frameBorder="0" allowFullScreen={true}></iframe>
      </div>
    </Modal>
  );
};

export default CreativeLibrary;